import { round, bignumber, BigNumber } from 'mathjs';

export const DECIMALREGEX = /,|\./g;
export const THOUSANDSREGEX = /\B(?=(\d{3})+(?!\d))/g;
const SCIENTIFICREGEX = /\.([0-9]*[1-9])?0*/g;

export const numberFormatter = (numberAsStr: string, decimal: string, grouping: string): string => {
    const number = parseFloat(numberAsStr);

    if (number > 10000 || number < -10000) {
        return removeDecimalsAndApplySeparator(number, grouping);
    }
    if (number >= 1 || number <= -1) {
        return applyTwoDecimals(number, decimal, grouping);
    }
    if (number === 0) {
        return '0';
    }

    return applySixDecimals(bignumber(number), decimal);
};

export const applyTwoDecimals = (number: number, decimal: string, grouping: string): string => {
    const removedExcessDecimals = number.toFixed(2);

    return parseFloat(removedExcessDecimals).toString().replace(DECIMALREGEX, decimal).replace(THOUSANDSREGEX, grouping);
};

const applySixDecimals = (number: BigNumber, decimal: string): string => round(number, 6).toString().replace(DECIMALREGEX, decimal);

export const applyScientific = (number: number, decimal: string, exponential: number): string =>
    number.toExponential(exponential).replace(SCIENTIFICREGEX, '.$1').replace(DECIMALREGEX, decimal);

export const removeDecimalsAndApplySeparator = (number: number, grouping: string): string =>
    Math.floor(number).toString().replace(THOUSANDSREGEX, grouping);
